// jQuery wrapper
(function($) {

    /**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');

		// Splash screen 
		$('body.home').addClass('splash-loaded');


		// Header bar scrolled
		scrollbarState();


        // Menu - Hamburger
		$('.hamburger').click(function() {
			// var target = $(this).data('target');

			// If any menus open (icon active)
			if ( $('body').hasClass('menu-open') ) {
				$(this).removeClass('is-active');

				$('body').removeClass('menu-open');

			// If none open
			} else {
				$(this).addClass('is-active');

				$('body').addClass('menu-open');
			}
		});


        // Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - headerHeight;
			// var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});


		// InView - Animate when in viewport
        $(".animate").on("inview", function(event, isInView) {
            var element = $(this);

            if (isInView) {
                element.addClass("ani-trigger");
            } 
        });


		// Home - Showcase
		if ($('.showcase-grid').length > 0) {
			$('.showcase-grid').packery({
				itemSelector: '.showcase-item',
				gutter: 20
			});

			$('.showcase-item .info-trigger').on('click', function() {				
				var target = $(this).data('target');

				$('.showcase-item').removeClass('open');
				$(target).addClass('open');

				$('.showcase-grid').packery();
			});
		}


		// Video modal toggle open/closed
	    $('.video-toggle').click( function() {
	    	var target = $(this).data('target');
	    	$(target).modal('toggle');
	    });
    	// Video modal - Empty player on close	    
        $('.close-video').click( function() {
        	$('.video-container').empty();
        });


		/*
		// Grid (Art, Culture)
		$('.grid').masonry({
			// options
			itemSelector: '.grid-item',
		});
		*/

		// Showcase Grid
		

		// The List - Filters
		if ($('#list-filter').length > 0) {
			$('#list-filter select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				// placeholder: 'Filter',
				//dropdownCssClass: 'filter_dropdown',
			});

			$('#list-filter select').on('change', function() {
				var val = $(this).val();
				if ( val != '#' ) {
					// window.location.href = window.location.host + "/" + val;
					window.location = val;
				}
			});
		}

		// The List - Show / Hide Thumbnails
		if ( $('#list-grid').length > 0) {
			theListThumbnails();

			window.almComplete = function(el){
				theListThumbnails();
			}
		}
		

        /***
		 * Carousels
		 ***/

		// Hero Carousel
		if ($('.hero-carousel').length > 0) {
			$('.hero-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.hero-prev'),
				nextArrow: $('.hero-next')
			});
		}

		// Culture Carousel (homepage)
		if ($('.culture-carousel').length > 0) {
			$('.culture-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				// autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.culture-prev'),
				nextArrow: $('.culture-next'),
				// asNavFor: $('.culture-controls')
			});
		}


		// Art & Culture - Image Carousel
		if ($('.image-carousel').length > 0) {
			$('.image-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				// autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.image-prev'),
				nextArrow: $('.image-next'),
				// asNavFor: $('.culture-controls')
			});
		}

		// Art & Culture - Art articles
		if ($('.art-carousel').length > 0) {
			$('.art-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				// autoplaySpeed: 5000,
				fade: false,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.art-prev'),
				nextArrow: $('.art-next'),
				// asNavFor: $('.culture-controls')
			});
		}


		// The List - Password Protection
		const listPassword = "TheList";
		$('#password-form').on('submit', function(event) {
			event.preventDefault();
			
			// Get the input password
			const enteredPassword = $('#password').val();
			
			// Check if the password matches
			if (enteredPassword === listPassword) {
				// Set a cookie for 24 hours
				$.cookie('list_access', 'true', { expires: 1, path: '/' });
				
				// Reload the page to show the content
				location.reload();
			} else {
				// Show error message if the password is incorrect
				$('#error-message').show();
			}
		});



    }); // End Document Ready


    // On load
	$(window).on('load', function() {

    });


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

    });


    // On Resize
	$(window).on('resize', function () {

    });


	// Header bar scrolled
	function scrollbarState() {
    	var navHeight = $('#site-header').outerHeight();

		if ( $(document).scrollTop() > navHeight ) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
    		$('body').removeClass('scrolled');
    		$('#site-header').removeClass('is-scrolled');
		}
	}

	
	// The List - Thumbnails
	function theListThumbnails() {
		$('.carousel-controls button').click( function() {
			var target_carousel = $(this).data('target'),
				target_slide = $(this).data('slide');

			$(target_carousel + ' .img').removeClass('current');
			$(target_carousel + ' .img-' + target_slide).addClass('current');

			$(target_carousel + ' button').removeClass('current');
			$(this).addClass('current');
		});
	}


// end jQuery wrapper
})(jQuery);
